/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class BaseRepository extends fx.Model {

    constructor(model, saver, history) {
        super(null, {
            saver: saver ? saver : (saver !== false ? shared.EditorSaver : false),
            history: history ? history : (history !== false ? shared.EditorHistory : false)
        });

        if (!models)
            models = {};

        let defaults = {
            creation: {}, // 
            account: new models.User({ id: "" }),
            servers: new repositories.ServersRepository(),
            fonts: new repositories.FontsRepository(),
            masks: new fx.ModelArray(),
            photos: new repositories.PhotosRepository(),
            stickers: new repositories.StickersRepository(),
            shapes: new repositories.ShapesRepository(),
            backgrounds: new repositories.BackgroundsRepository(),
            texts: new repositories.TextsRepository(),
            layouts: new repositories.LayoutsRepository(),
            customcolors: new repositories.CustomColorsRepository(),
            google: new repositories.GoogleRepository(),
            albums: new repositories.AlbumsRepository(),
            sharedPhotos: new fx.ModelArray(),
            guests: new fx.ModelArray(),
            productTypes: new fx.ModelArray([]),
            optionsChoices: new fx.ModelArray([])
        };

        this.init({ ...defaults, ...model });

        this.NB_UPDATES_BEFORE_SAVING = 20;
        this.MAX_SAVE_TRIES = 3;

        fx.set("fonts", this.fonts);
        fx.set("servers", this.servers);
        fx.set("texts", this.texts); // TODO : move to books
        fx.set("lang", new models.Lang({}));

        fx.set("productTypes", this.productTypes);

        this.prop("photofilters", new filters.PhotoFilters());

        this._saving = false;
        this._autoSave = true;
        this._needUpdateReport = false;

        this._checkUpload = false;
        this._checkUploadProcessed = false;

        this._saveTries = 0;
        this._serverIndex = 0;
        
        this._oldAccountid = false;
        this._countPhotos = 0;
        

        this.repeat(this.save, 60000);
    }

    get product()
    {
        if (this._product) return this._product;

        return this.creation.product;
    }

    set product(val)
    {
        this._product = val;
    }

    get autoSave() {
        return this._autoSave;
    }

    set autoSave(val) {
        this._autoSave = val;
    }

    get saving() {
        return this._saving;
    }

    set saving(val) {
        this._saving = val;
    }

    get checkUpload() {
        return this._checkUpload;
    }

    set checkUpload(val) {
        this._checkUpload = val;
    }

    get checkUploadProcessed() {
        return this._checkUploadProcessed;
    }

    set checkUploadProcessed(val) {
        this._checkUploadProcessed = val;
    }

    // compatibility with config
    get creationModel() {
        return this;
    }

    get creationid() {
        return this._creationid;
    }

    set creationid(val) {
        this._creationid = val;
    }

    get productid() {
        return this._productid;
    }

    set productid(val) {
        this._productid = val;
    }

    get connectionid() {
        return fx.get("connectionid");
    }

    set connectionid(val) {
        fx.set("connectionid", val);
    }


    get creationProductOption() {
        return this._creationProductOption;
    }

    set creationProductOption(val) {
        this._creationProductOption = val;
    }

      // case for posters with background removal
    get hasFilteredPhoto()
    {
        return this._hasFilteredPhoto;
    }

    set hasFilteredPhoto(val)
    {
        this._hasFilteredPhoto = val;
    }

    /*get modified()
    {
        // if _modified was never set, we use saver data to know if model was updated
        return super.modified || (this.creation && !this.creation.started && !this.creation.deleted); // In case of IA book, it is deleted when created
    }*/

    get visibleMasks() {
        return this.masks.filter((mask) => mask.visible);
    }

    get updatesSavedLocally() {
        if (!this._updatesSavedLocally)
            this._updatesSavedLocally = this.readData("updatesSavedLocally");

        return this._updatesSavedLocally;
    }

    set updatesSavedLocally(data) {
        if (data == null)
            this.removeData("updatesSavedLocally");
        else
            this.storeData("updatesSavedLocally", data);

        this._updatesSavedLocally = data;
    }


    get photosorts() {
        let sorts = [new filters.SortPhotosAdded("DESC", true), new filters.SortPhotosChronological(this)];
        if (this.guests.length > 0)
            sorts.push(new filters.SortPhotosByPerson(this.guests));

        return sorts;
    }

    /**
     * A creation is created deleted (deleted = 1), so an album abandoned by the client never
     * shows up in his account. It is undeleted as soon as he really worked on it : the first
     * update the history records. Editors arm this with undeleteOnFirstUpdate() ; screens that
     * only need to know whether it happened read modifiedByUser.
     */
    get modifiedByUser() {
        return !!this.creation && !this.creation.deleted;
    }

    undeleteOnFirstUpdate() {
        // only an editor arms this, so undelete() stays without effect anywhere else (the config
        // editor works on the same repository classes, on creations it must not resurrect)
        this._undeleteArmed = true;

        if (!this.history || this.modifiedByUser)
            return;

        this.on("updated", this._onFirstUpdate, this.history);
    }

    /**
     * Saving and leaving, or ordering, keeps the album whatever the client did to it.
     */
    undelete() {
        if (!this._undeleteArmed || this.modifiedByUser)
            return;

        this.creation.deleted = 0;
    }

    _onFirstUpdate() {
        // the history also raises "updated" when it is undone back to its start : nothing done then
        if (!this.history.canUndo)
            return;

        this.off("updated", this._onFirstUpdate, this.history);

        this.creation.deleted = 0;
    }

    report(raw) {
        this._needUpdateReport = false;

        return { pages: [], failed: false };
    }

    // ----------------------- //

    /**
    * We override here this function because we need to automate saving
    */
    onUpdated(action) {
        super.onUpdated(action);

        // when a media (Photo/Background/Sticker/...) is used/unused anywhere in application, 
        // here we count how many times
        if (action.impacts("content") && action.model instanceof models.CreationElementContent) {
            if (action.tag == "update-id")
                return;

            if (action.previous.content != action.model.content) {
                this.useMedia(action.model.component_type, action.previous.content, false, action.history);
                this.useMedia(action.model.component_type, action.model.content, true, action.history);
            }
        }

        if (action.type == "removeItem" && action.data instanceof models.CreationElementContent)
            this.useMedia(action.data.component_type, action.data.content, false, action.history);

        if ((action.type == "addItem" || action.type == "addItemAt") && action.data instanceof models.CreationElementContent)
            this.useMedia(action.data.component_type, action.data.content, true, action.history);

        // case when a picture is deleted, so all pages containing that picture have to be updated
        if (action.type == "update" && action.impacts("deleted") && action.model instanceof models.Photo && action.data.deleted)
            this.creation.removePhoto(action.model);

        // we save automatically our model everytime we reach a number of udpdates
        if (this.autoSave && this.saver && this.saver.lastUpdates.length > this.NB_UPDATES_BEFORE_SAVING)
            this.delay(this.save, 250);

        this._needUpdateReport = true;
    }


    onDataEvent(e) {
        super.onDataEvent(e);

        // "Sauver & Quitter" : the client keeps his album, so it has to show in his account.
        // Set before the main asks for the save, so the update goes with it.
        if (e.type == "exit-editor")
            this.undelete();

        if (e.type == "login-succeed" || e.type == "register-succeed") 
        {
            if ( fx.service("MediasUploader").uploading && this.creation.accountid != this.account.id)
                this._oldAccountid = this.creation.accountid;
            
            this.connectionid = this.account.token;
            this.creation.accountid = this.account.id;
            this.photos.updateAccountId(this.creation.id, this.account.id);
        }

        /*if (e.type == "upload-finished" && this._oldAccountid)
        {
            this.photos.reaffectPhotos(this.creation.id, this._oldAccountid);
            this._oldAccountid = null;
        }*/

        if (e.type == "reaffect-photos")
        {
            if (this._oldAccountid)
            {
                this.photos.reaffectPhotos(this.creation.id, this.account.id, this._oldAccountid);
                this._oldAccountid = null;
            }
        }

        if (e.type == "creation-loaded")
            this.fonts.addEmpty();

        if (e.type == "font-family-updated") {
            this.creation.last_font_family = e.detail;

            this.fonts.changeCount(e.detail);
        }

        if (e.type == "text-color-updated")
            this.creation.last_color = e.detail;

        if (e.type == "font-size-updated")
            this.creation.last_font_size = e.detail;

        if (e.type == "align-updated")
            this.creation.last_align = e.detail;

        if (e.type == "load-layout-medias") {
            let medias = e.detail;

            for (const id in medias) {
                switch (medias[id].type) {
                    case "background":
                        this.backgrounds.addElement(id, medias[id].object);
                        break;

                    case "sticker":
                        this.stickers.addElement(id, medias[id].object);
                        break;
                }
            }
        }

        // case when picture is uploaded, and get it's final id
        // we need to update all pages containing temporary photo id with this final id.
        if (e.type == "media-file-uploaded")
            this.creation.updatePhotos(e.model.id, e.model.oldid);

        if (e.type == "media-file-extracted")
            this.creation.updatePhotosData(e.model.id);

        // user selected photos from an album
        if (e.type == "album-photos-copied")
            this.photos.addItem(e.detail);

        if (e.type == "apply-effect")
        {
            let server = this.servers.uploadServers.getItemAt(this._serverIndex);
            
            let effect = e.data.effect;
            let imageWidth = e.data.imageWidth;
            let imageHeight = e.data.imageHeight;
            let photo = e.model;

            photo.processing = true;

            this.post(server.api + "effect", {
                id: photo.id,
                filter: effect,
                imageWidth : imageWidth,
                imageHeight : imageHeight,
            }, this._effectApplied);

        }
    }

    _effectApplied(e)
    {
        
        let photo = e.photo ? this.photos.find({id : e.photo.id}) : null;

        if (photo)
            photo.processing = false;

        if (e.success)
        {    
            photo.update({  processing : false, 
                            urls : e.photo.urls, 
                            effects : e.photo.effects });
        }
        
            

        this.event("effect-applied");
    }

    /**
     * We can load a book from an id
     * @param {int} bookid 
     */
    load(creationid, lang) {
        if (!creationid)
            creationid = this.creationid;

        if (this.updatesSavedLocally)
            this._rescueUpdates();
        else
            this.post("/app/load", {
                creationid: creationid,
                fonts: this.fonts.length == 0,
                lang: lang ? lang : fx.currentLang()
            }, this._loaded);

        this.event("creation-loading");
    }

    loadOptions() {
        if (!this.creation.creationOptions)
            this.post("/app/creationoptions", { product_type_id: this.creation.product_type_id }, this.optionsLoaded);
        else
            this.event("creation-options-loaded")
    }

    optionsLoaded(data) {
        if (data.error)
            this.event("load-creation-options-error", data);
        else {
            this.creation.creationOptions = data;
            this.event("creation-options-loaded");
        }
    }

    // TODO : make this call the same as the real save, creationid whould be in updates 
    _rescueUpdates() {
        let data = {
            updates: this.updatesSavedLocally,
            id: this.creationid,
            contextid: "",
            connectionid: this.connectionid,
            exit: "updatesSavedLocally",
            device: fx.browser.device,
        };

        this.post("/app/save", { data: JSON.stringify(data) }, this._onRescueUpdates, {maxTries : 1, timeout : 0});
    }

    _onRescueUpdates(data) {
            this.updatesSavedLocally = null;
            this.load(this.creationid);
    }

    loadPreview() {
        //this.creationid = creationid;

        this.post("/app/preview", { action: "preview", creationid: this.creationid }, this._loaded);

        this.event("creation-loading");
    }

    _loaded(data) {
        if (data && data.error) {
            this.event("load-creation-error", data.details.message);
        }
        else {
            this.initData(data);
            this.event("creation-loaded", this.creation);
        }

        this.checkUploadedPhotos();
        //this.on("photo-upload-finished", this._onPhotoUploaded, fx.service("MediasUploader"));
    }


    // TO override
    initData(data) {
        fx.get("lang").init(data.lang);

        this.account.init(data.account);
        this.connectionid = this.account.token;

        if (data.settings)
        {
            fx.get("settings").init(data.settings);
            fx.set("debugging", fx.get("settings").debugging);
        }

        if (this.history)
            this.history.maxActionsStored = fx.get("settings").maxHistoryActionsStored;

        if (data.servers) {
            if (this.servers.length > 0)
                this.servers.addItem(data.servers);
            else
                this.servers.init(data.servers);
        }

        if (data.fonts)
            this.fonts.init(data.fonts);

        this.productTypes.init(data.productTypes);

        this.masks.init(data.masks);
        this.photos.init(data.photos);
        this.stickers.init(data.stickers);
        this.backgrounds.init(data.backgrounds);

        this.hasFilteredPhoto = data.hasFilteredPhoto;

        this.backgrounds.categories = data.backgrounds_categories;
        this.stickers.categories = data.stickers_categories;

        if (data.texts)
            this.texts.init(data.texts);

        if (data.layouts)
            this.layouts.init(data.layouts);

        if (data.customcolors)
            this.customcolors.init(data.customcolors);

        this.prop("photofilters", new filters.PhotoFilters());

        this.event("repository-initialized");
    }

    create() {
        this.post("/app/create", { product_id: this.productid, formatid: this.choosedFormat }, this.onCreateData);

        this.event("create-creation");
    }

    onCreateData(data) {
        if (data.error) {
            this.event("create-creation-error", data);
            return;
        }

        this.initData(data);
        this.event("creation-created", this.creation);
    }

    loadLayoutMedias(medias) {
        this.post("/app/loadlayoutmedia", { medias: medias }, this._loadedLayoutMedias);
    }

    // Warm media only : unlike loadLayoutMedias it never emits "layout-medias-loaded", which re-renders every Area.
    preloadLayoutMedias(medias) {
        this.post("/app/loadlayoutmedia", { medias: medias }, this._preloadedLayoutMedias);
    }

    _preloadedLayoutMedias(data) {
        if (!data.error)
            this.event("load-layout-medias", data);
    }

    _loadedLayoutMedias(data) {
        if (data.error)
            this.event("load-layout-medias-error", data);
        else {
            this.event("load-layout-medias", data);

            this.event("layout-medias-loaded");
        }
    }

    // -------------------- //
    save(saveReason) {

        if (!this.saver) return;
        
        let force = (saveReason === true || saveReason == "cover-saved");

        if (saveReason == "cover-saved")
            saveReason = this._saveReason;

        if (!this.creation.id || !this.modified) {
            this.saving = false;
            this.event("creation-saved");
            return;
        }

        if (this.saving && !force) {
            if (saveReason)
                this.event("creation-saving");
            return;
        }

        this.saving = true;
        this.event("creation-saving");

        // this.creation.cover doesn't exit on print where there is no pages
        if (this.creation.cover && (this.creation.cover.modified || !this.creation.started)) // !deleted for books created by IA, there are first created with deleted == 1, and deleted is set to 0 only if user goes to the last step of IA process.
        {
            this.creation.started = 1;
            this._saveReason = saveReason;
            this.on("thumb-generated", this._onCoverGenerated, fx.service("ThumbGenerator"));
            fx.service("ThumbGenerator").generate(this.creation);
        }
        else {
            if (this.creation.started == 0)
                this.creation.started = 1;

            this._saveReason = undefined;

            if (saveReason == "exit-editor" || saveReason == "order-confirmed") {
                this.checkUploadedPhotos();

                this.updateStoredReport(this.report(true));
            }

            super.save({
                url: "/app/save",
                force: force,
                params: {
                    id: this.creation.id,
                    contextid: this.creation.contextid,
                    connectionid: this.connectionid,
                    exit: saveReason,
                    device: fx.browser.device,
                    coverthumb: fx.service("ThumbGenerator").base64 || undefined
                }
            });

            this.updatesSavedLocally = this.saver.prepareUpdatesForSending(true);
        }
    }

    _onCoverGenerated() {
        this.off("thumb-generated", this._onCoverGenerated, fx.service("ThumbGenerator"));

        if (this.creation.cover)
            this.creation.cover.modified = false;

        this.save("cover-saved");
    }

    // The report column holds a json object : the pages report written when leaving the
    // editor, plus anything else the editor has to remember on the creation.
    get storedReport() {
        if (!this.creation.report)
            return {};

        try {
            return JSON.parse(this.creation.report) || {};
        }
        catch (e) {
            return {};
        }
    }

    // merges values into the report column, keeping the keys it already holds
    updateStoredReport(values) {
        let report = Utils.stringify(Object.assign(this.storedReport, values), 3);

        if (report != this.creation.report)
            this.creation.update({ report: report });
    }

    getOptions() {
        this.post("/app/options", { creationid: this.creation.id }, this._onOptionsData);
    }

    _onOptionsData(data) {
        if (data && data.optionsChoices) {
            this.optionsChoices.removeAll();
            for (var i = 0; i < data.optionsChoices.length; i++)
                this.optionsChoices.addItem(data.optionsChoices[i]);

            this.event("options-loaded");
        }
    }

    onSaved(data) {
        //super.onSaved(data);

        this.saving = false;

        if (!data.error) {
            // saved went fine, we don't store last update in local storage
            this.updatesSavedLocally = null;
            this._saveTries = 0;

            fx.service("ThumbGenerator").clean();

            if (this.saver.lastUpdates.length > 0)
                this.save();
            else 
            {
                this.event("creation-saved");

                if (data.contextChanged)
                    this.event("new-editor-opened", null, 1000); // we add a delay, so in case we are exiting, popup will never be displayed
            } 
        }
        else 
        {
            if (this._saveTries++ < this.MAX_SAVE_TRIES)
                this.save();
            else
                this.event("save-creation-error");
        }
    }


    // temporary fix for pictures uploaded but content not updated 
    checkUploadedPhotos() {
        let ready = true;

        for (let i = 0; i < this.photos.length; i++)
            this.photos.getItemAt(i)._number = 0;

        for (let i = 0; i < this.creation.elements.length; i++) {
            let page = this.creation.elements.getItemAt(i);

            for (let j = 0; j < page.components.length; j++) {
                let component = page.components.getItemAt(j);

                if (component.isPhoto) {
                    if (Utils.isID(component.content)) {
                        let photo = this.photos.find({ temporaryId: component.content });
                        if (photo) {
                            if (Utils.isID(photo.id)) {
                                if (!fx.service("MediasUploader").toBeUploaded(photo)) {
                                    fx.service("MediasUploader").upload(photo);
                                    ready = false
                                }
                            }
                            else
                                component.update("update-id", { content: photo.id });
                        }
                    }

                    let photo = this.photos.find({ id: component.content });
                    if (photo)
                        photo._number++;

                }
            }
        }

        for (let i = 0; i < this.photos.length; i++)
            this.photos.getItemAt(i).number = this.photos.getItemAt(i)._number;

        return ready;
    }


    useMedia(type, id, use, history) {
        if (!id) return;

        switch (type) {
            case "background":
                this.backgrounds.use(id, use, history);
                break;

            case "sticker":
                this.stickers.use(id, use, history);
                break;

            case "photo":
            case "image":
                this.photos.use(id, use, history);
                break;

            // TEXTS AND LAYOUTS don't need for now to be flaged as used or not in UI, but we still keep up to date this data if UI changes.
            case "text":
                this.texts.use(id, use, history);
                break;

            case "layout":
                this.layouts.use(id, use, history);
                break
        }

    }

    // used so we don't wait until upload finishes to reaffect photos.
    /*_onPhotoUploaded()
    {
        if (this._oldAccountid)
        {
            this._countPhotos++;

            if (this._countPhotos >= fx.get("settings").maxUploads)
            {
                this.photos.reaffectPhotos(this.creation.id, this.account.id, this._oldAccountid);
                this._oldAccountid = null;
            }
        }
    }*/

    // Albums 
    loadAlbums() {
        this.albums.loadAlbums(this.creation.id, this.account.id, this.connectionid);
    }

    loadAlbumPhotos(id) {
        this.albums.loadAlbumPhotos(id, this.account.id, this.connectionid);
    }

    copyAlbumPhotos(files) {
        this.albums.copyPhotos(files, this.account.id, this.creation.id, this.connectionid);
    }

    addProductMedias(product) {
        this.stickers.addItem(product.stickers.toArray(), true);
        this.backgrounds.addItem(product.backgrounds.toArray(), true);
    }

    addPhotosForCreation()
    {
        // to override
    }


});
